export default function CasinoWRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 920px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                `}
            </style>

            <div class="modal fade show" style={{ display: "block", marginBottom: "20px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Casino War (Virtual)</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To guess the positions that will win against the Dealer card.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b> Hands dealt:</b> 7 (6 for Player, 1 for Dealer)</p>
                                            <p class="pt20"><b>Bets</b>: Player Card(s) higher than Dealer card wins</p>
                                            <p class="pt20"><b>Number Ranking</b>: Lowest to highest: Ace, 2, 3, 4, 5, 6, 7, 8, 9, 10, Jack, Queen, and King (when Ace is "1" and King is "13").</p>
                                            <p class="pt20">
                                                <b>Suit Ranking</b>(Highest to Lowest): Spades, Hearts, Clubs, Diamonds
                                            </p>
                                        </div>

                                        <div>
                                            <div>
                                                <center><h3>PAYOUTS</h3></center>
                                                <div>
                                                    <p class="pt20">Payout as per the bet placed. </p>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>p1</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>
                                                            <tr>
                                                                <th>p2</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>p3</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>p4</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>p5</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>

                                                            <tr>
                                                                <th>p6</th>
                                                                <th>
                                                                    1 to 0.98
                                                                </th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}